<template>
    <div class="row no-padding">
        <div class="container">
            <h4 class="text-center">🤦🏻‍♂️ {{'Missed opportunities' | trans}}</h4>
            <Spinner v-if="waitingForMissedJobs" v-bind:title="'Loading Missed Jobs ...'"></Spinner>
            <ul class="list-group">
                <li v-for="item in dataFromPelican.data"
                    class="list-group-item list-group-item-action corner-radius custom-padding">
                    <div class="row outer-height-adjustment">
                        <div class="col-xs-8 col-sm-8 col-md-10 col-lg-10 inner-height-adjustment">
                            <h4 class="mb-1">{{translateFromDatabase(item.line1)}}</h4>
                        </div>
                        <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2 inner-height-adjustment">
                            <small class="pull-right time-since">{{timeSince(item.date_add) | trans}}</small>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <p class="mb-1 line2">{{translateFromDatabase(item.line2)}}</p>
                            <small class="line3">{{translateFromDatabase(item.line3)}}</small>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import translations from '../../translations';
    import Spinner from '../Spinner';

    export default {
        props: {},
        data() {
            return {
                conditionLanguageSelected: null,
                conditionLanguage: [
                    {value: 'fr'},
                    {value: 'nl'},
                    {value: 'en'},
                ],
                dataFromPelican: [],
                waitingForMissedJobs: true
            }
        },
        created() {
            this.getAndProcessDataPelican();
        },
        methods: {
            async getAndProcessDataPelican() {
                this.dataFromPelican = await this.$api.worker.missedJobs();
                if (this.dataFromPelican.success) {
                    this.waitingForMissedJobs = false;
                }
                this.$api.worker.readMissedJobs();
            },
            timeSince(date) {
                // Safari browser adjusted calculation for seconds
                const seconds = Math.floor((Date.parse(new Date().toString()) - Date.parse(new Date(date.replace(/-/g, "/")).toString())) / 1000);
                let interval = Math.floor(seconds / 31536000);
                let prefix = '';

                if (this.$options.filters.trans('second ago') === 'seconde') {
                    prefix = 'il y a ';
                }

                if (interval >= 1 && interval < 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('year ago');
                }
                if (interval >= 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('years ago');
                }
                interval = Math.floor(seconds / 2592000);
                if (interval >= 1 && interval < 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('month ago');
                }
                if (interval >= 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('months ago');
                }
                interval = Math.floor(seconds / 86400);
                if (interval >= 1 && interval < 2) {
                    return this.$options.filters.trans('yesterday');
                }
                if (interval >= 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('days ago');
                }
                interval = Math.floor(seconds / 3600);
                if (interval >= 1 && interval < 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('hour ago');
                }
                if (interval >= 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('hours ago');
                }
                interval = Math.floor(seconds / 60);
                if (interval >= 1 && interval < 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('minute ago');
                }
                if (interval >= 2) {
                    return prefix + interval + ' ' + this.$options.filters.trans('minutes ago');
                }
                if (seconds === 1) {
                    return prefix + seconds + ' ' + this.$options.filters.trans('second ago');
                } else if (seconds < 0) {
                    return prefix + '0 ' + this.$options.filters.trans('seconds ago');
                } else {
                    return prefix + seconds + ' ' + this.$options.filters.trans('seconds ago');
                }
            },
            translateFromDatabase(key) {
                return this.$options.filters.trans(key);
            }
        },
        computed: {},
        components: {
            Spinner
        }
    }

</script>

<style scoped>
    .inner-height-adjustment {
        margin-bottom: 0;
    }

    .outer-height-adjustment {
        margin-bottom: -1.4rem;
    }

    .line2 {
        color: #495057;
        font-size: 15px;
    }

    .line3 {
        font-size: 12.7px;
    }

    .time-since {
        color: #868e96;
        font-size: 12px;
        padding-top: 0.7rem;
    }

    .corner-radius:first-child {
        border-top-right-radius: 8px !important;
        border-top-left-radius: 8px !important;
    }

    .corner-radius:last-child {
        border-bottom-right-radius: 8px !important;
        border-bottom-left-radius: 8px !important;
    }

    .custom-padding {
        padding: 0 1.9rem 0.595rem 1.9rem !important;
    }

    .custom-padding:first-child {
        padding-top: 0.65rem !important;
    }
</style>
